import React from 'react'
import { Flex, Box } from '@chakra-ui/react';

const About = ({ content }) => {
    return (
        <Box>
            {content}
        </Box>
    )
}

export default About